import { useEffect, useRef } from "react";

type CloseHandler = () => void;

const stack: CloseHandler[] = [];

export function closeTopModal(): boolean {
  const top = stack[stack.length - 1];
  if (!top) return false;
  top();
  return true;
}

// Registers once per open, so the stack follows open order. Callers usually pass an inline onClose;
// re-registering on every render would move a re-rendering modal (e.g. a ticking timer) above one
// opened after it, and Android Back would close the wrong modal.
export function useBackCloseable(active: boolean, onClose: CloseHandler) {
  const latest = useRef(onClose);
  latest.current = onClose;

  useEffect(() => {
    if (!active) return;
    const handler = () => latest.current();
    stack.push(handler);
    return () => {
      const index = stack.lastIndexOf(handler);
      if (index !== -1) stack.splice(index, 1);
    };
  }, [active]);
}
